import React from 'react';

/**
 * Renders a user avatar — handles both emoji and uploaded image avatars.
 * Usage: <Avatar user={user} size={20} /> or <Avatar avatar={str} avatarType={type} size={20} />
 */
export default function Avatar({ user, avatar, avatarType, size = 20, className = '', style = {} }) {
  const src = avatar ?? user?.avatar;
  const type = avatarType ?? user?.avatarType;
  const isImage = type === 'upload' && src?.startsWith('data:');

  if (isImage) {
    return (
      <img
        src={src}
        alt=""
        className={className}
        style={{ width: size, height: size, borderRadius: '50%', objectFit: 'cover', ...style }}
      />
    );
  }

  return <span className={className} style={{ fontSize: size, lineHeight: 1, ...style }}>{src || '\uD83D\uDC64'}</span>;
}
